<template>
    <div class="dropdown d-block" v-if="content">
        <button class="btn btn-link p-0 ms-1" data-bs-toggle="dropdown" ref="button">
            <i class="fas fa-question-circle"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end dropdown-help shadow fw-normal p-3" v-html="content"></div>
    </div>
</template>

<script lang="ts">
import {Dropdown} from 'bootstrap';
import {defineComponent, onMounted, PropType, ref} from 'vue';
import htmlFiles from './parameterHelpHtml';

export default defineComponent({
    props: {
        name: {
            type: String as PropType<keyof typeof htmlFiles.common>,
            required: true,
        },
        estateType: {
            type: String as PropType<keyof typeof htmlFiles>,
            required: true,
        },
    },
    setup(props) {
        const button = ref<HTMLElement | null>(null);
        const content = htmlFiles[props.estateType][props.name] || htmlFiles.common[props.name] || null;

        let dropdown: Dropdown;

        onMounted(() => {
            if (button.value) {
                dropdown = new Dropdown(button.value);
            }
        });

        return {button, content};
    },
});
</script>
